import { render } from "./TooltipBody.vue?vue&type=template&id=b9ad3100&lang=pug"
import script from "./TooltipBody.vue?vue&type=script&lang=js"
export * from "./TooltipBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__